module.exports = __webpack_public_path__ + "static/media/m-penguin-fishing.8ea654b4.png";